// extracted by mini-css-extract-plugin
export default {"main":"ErrorPage_main__tOfy2"};